import { Injectable } from '@angular/core';

interface IMonth {
    name: string;
    value: number;
}

export const MONTHS_LIST: IMonth[] = [
    { name: 'Gennaio', value: 0 },
    { name: 'Febbraio', value: 1 },
    { name: 'Marzo', value: 2 },
    { name: 'Aprile', value: 3 },
    { name: 'Maggio', value: 4 },
    { name: 'Giugno', value: 5 },
    { name: 'Luglio', value: 6 },
    { name: 'Agosto', value: 7 },
    { name: 'Settembre', value: 8 },
    { name: 'Ottobre', value: 9 },
    { name: 'Novembre', value: 10 },
    { name: 'Dicembre', value: 11 }
];

@Injectable()
export class UtilsDateService {
    monthList = MONTHS_LIST;
    monthListFuture: IMonth[];
    yearListFuture: number[];
    constructor() {
        this.yearListFuture = this._yearListFuture();
        this.monthListFuture = this._monthListFuture();
    }

    private _monthListFuture() {
        const startMonth0_11 = new Date(Date.now()).getMonth();
        let nextMonth = startMonth0_11 + 1;
        const array: IMonth[] = [];
        for (let count = 0; count <= 11; count++) {
            if (nextMonth === 12) {
                nextMonth = 0;
            }
            array.push(this.monthList[nextMonth]);
            nextMonth += 1;
        }
        return array;
    }
    private _yearListFuture() {
        const extension = 20;
        const start = new Date(Date.now()).getFullYear();
        const array = [];
        for (let i = 0; i < extension; i++) {
            array.push({ label: (start + i).toString(), value: start + i });
        }
        return array;
    }
    inputDateGetter(date: Date): string {
        // console.log("inputDateGetter date = '", date, "'");
        let _date = null;
        if (date != null) {
            _date = new Date(date).toISOString().split('T')[0];
        }
        // console.log("inputDateGETTER RETURN  date = '", date, "'");
        return _date;
    }
    inputDateSetter(date: string): Date {
        // console.log("inputDateSetter date = '", date, "'");
        let _date = null;
        if (date != null && date.length > 0) {
            _date = new Date(date);
        }
        // console.log("inputDateSETTER RETURN  date = '", date, "'");
        return _date;
    }

    getMonth(date: Date) {
        if (date == null) {
            return null;
        }
        const _date = new Date(date);
        return _date.getMonth();
    }
    setMonth(month: number, date: Date, dayOfMonth: number = null): Date {
        if (month < 0 || month > 11) {
            console.error(`${dayOfMonth} is not between 0 and 11.`);
        }
        if (month == null) {
            return date;
        }
        if (date == null) {
            date = new Date();
        }
        const _date = new Date(date);
        if (dayOfMonth) {
            _date.setMonth(month, dayOfMonth);
        } else {
            _date.setMonth(month);
        }
        return _date;
    }

    getYear(date: Date) {
        if (date == null) {
            return null;
        }
        const _date = new Date(date);
        return _date.getFullYear();
    }

    setYear(year: number, date: Date) {
        if (year == null) {
            return date;
        }
        const _date = new Date(date);
        _date.setFullYear(year);
        return _date;
    }
}



// WEBPACK FOOTER //
// ./src/app/helpers/utils-date.service.ts